import { render } from "./footer-ins.vue?vue&type=template&id=5acb6ba2"
import script from "./footer-ins.vue?vue&type=script&lang=js"
export * from "./footer-ins.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__